import { render } from "./ModulTaskPage.vue?vue&type=template&id=92b2a21c"
import script from "./ModulTaskPage.vue?vue&type=script&lang=js"
export * from "./ModulTaskPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__